module.exports = "<h1 class=\"mat-headline\">{{scene.header}}</h1>\r\n\r\n<div \r\n    *ngIf=\"scene.imageUrl !== '' && scene.imageUrl !== null && scene.imageUrl !== undefined\" \r\n    class=\"image-container\">\r\n    <img src=\"{{scene.imageUrl}}\" />\r\n</div>\r\n\r\n<span class=\"mat-body-1\">{{scene.description}}</span>"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/runner/scene/scene.component.html
// module id = ../../../../../src/app/runner/scene/scene.component.html
// module chunks = main